import React, { useState } from "react";
import { Input, Button, Upload, Select, Form, message, Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import Type from '@actionTypes'
import "../OperationCard/operationCard.less";

const { Option } = Select;
const { Item } = Form;
const layout = {
  labelAlign: "left",
  // labelCol: { span: 4 },
  // wrapperCol: { span: 12 },
};
const { confirm } = Modal

const Uploads = (props) => {
  const { showType, sourceTree, onCancel, getDoc,cardPath,systemNum } = props;
  const caseDetail = useSelector((state) => state.caseDetail) || {};
  const data = caseDetail?.[systemNum]?.[`mediationInfo/mediationInfo`]?.mediationInfoArray
  const [resType, setResType] = useState(0);
  const [file, setFile] = useState({});
  const dispatch = useDispatch()
  const { activeKey, activeTab } = useSelector((state) => state.menuInfo);

  const path = activeTab.pathUrl;

  const selectSourceTree = (e, arr) => {
    switch (e) {
      case "executionLegalDoc":
        return arr?.execFile || [];
      case "litiprsvLegalDoc":
        return arr?.litigationFile || [];
      case "litigationLegalDoc":
        return arr?.lawsuitFile || [];
      case "originalEvidence":
        return arr?.originalFile || [];
      case "mediationLegalDoc":
        return arr?.mediationFile || [];
      default:
        return [];
    }
  };

  const handleOK = (uploadTime = 0) => {
    if(Array.isArray(data)  && data?.length ===0) {
      message.warn('请先调解登记')
      return
    }
    if (resType === 0) {
      message.warning('请选择类型');
      return;
    }
    if (!file?.name) {
        message.warning('请先选择文件');
        return;
    }
    dispatch({
        type: Type.GET_DZJZUPLOAD,
        params: { file, resType , uploadTime,mediationInfoId:data[0].id},
        path,
        systemNum,
        cb: () => {
            message.success('上传成功');
            onCancel()
            getDoc()
        },
        cbCf: () => {
            onCancel()
            confirm({
                title: '存在重复文件',
                content: '已存在同类型或同名文件，请确认是否继续上传？继续上传将覆盖已有文件',
                onOk() {
                  handleOK(1);
                },
            });
        },
        cbError: () => {
          onCancel()
          message.error('文件上传失败');
        }

    });
  }

  return (
    <div className="modal-content">
      <div className="modal-header">文件上传</div>
      <div className="content">
        <Form
          {...layout}
          // onFinish={onFinish}
        >
          <Item label="文件类型">
            <Select
              placeholder="请输入"
              style={{ marginLeft: 10 }}
              value={resType === 0 ? "" : resType}
              onSelect={(e) => setResType(e)}
              virtual={false}
            >

              {selectSourceTree(showType, sourceTree).map((e,index) => {
               return <Option
                style={e.value === 0 ? { display: 'none' } : null}
                key={e.value}
                value={e.value}
                name="resType"
                >
                {e.valueText}
                </Option>
              }
              )}
            </Select>
          </Item>
          <Item label="文件" style={{ marginBottom: 0 }}>
            <Item style={{ display: "inline-block", width: "35%" }}>
              <Input
                value={file.name}
                style={{
                  marginLeft: 38,
                  backgroundColor: "white",
                  color: "#333333",
                  marginRight: 10,
                }}
              />
            </Item>
            <span style={{marginLeft: 125}}>
              <Upload
                beforeUpload={(file) => {
                  setFile(file);
                  return false;
                }}
                showUploadList={false}
              >
                <Button type="primary">浏览</Button>
              </Upload>
            </span>
            {/* <Item style={{ display: "inline-block", width: "35%" }}> */}
          </Item>
          {/* </Item> */}
        </Form>
      </div>
      <div className="modal-footer">
        <Button onClick={onCancel}>取消</Button>
        <Button type="primary" onClick={() =>handleOK()}>确定</Button>
      </div>
    </div>
  );
};

export default Uploads;
